import React, {
  useState,
  Fragment,
  useCallback,
  useEffect,
  Suspense,
} from "react";
import { useForm } from "react-hook-form";
import {
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { Breadcrumbs, Btn, H4 } from "../../../../AbstractElements";
import DataTable from "react-data-table-component";
import CommonModal from "../../../Common/Component/CommonModal";
import RequiredField from "../../../../Constant";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import {
  CreateDiagnosisType,
  DeleteDiagnosisType,
  DiagnosisTypeList,
  UpdateDiagnosisType,
} from "../../../../apiController";
import Loader from "../../../../Layout/Loader";
import { override } from "../../../../Auth/Tabs/LoginTab";
import FadeLoader from "react-spinners/FadeLoader";
import { roles_permissions } from "../../../../Layout/Sidebar/Menu";


const DiagnosisType = () => {
  const [diagnosisTypes, setDiagnosisTypes] = useState([]);
  const [Large, setLarge] = useState(false);
  const [formdata, setFormdata] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const permission = roles_permissions.find((module)=> module.module_name === 'Diagnosis Type')

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm();

  const [searchKeyword, setSearchKeyword] = useState("");
  const handleSearchKeyword = (keyword) => setSearchKeyword(keyword);

  const LargeModaltoggle = (key) => {

    if(key === 'add'){
      setFormdata({id: "", diagnosistype: "" });
      setValue('diagnosistype', '')
      setValue('id', '')
    }
    setLarge(!Large);
    // console.warn(formdata.id)
    // if (!formdata.id) {
    //   setFormdata({});
    // }
  };

  const handleEdit = (row) => {
    console.log(row);
    // setFormdata({ id: row.id, diagnosistype: row.name });
    setLarge(!Large);
    reset({ diagnosistype: row.name });
    setValue('id', row.id)
    setValue('diagnosistype', row.name)
  };

  const type = diagnosisTypes.map((row, ind) => ({
    ind: ind + 1,
    id: row.id,
    diagnosistype: row.name,
    action: (
      <span key={ind}>
        <Btn
          attrBtn={{
            style: { width: 60, fontSize: 14, padding: 4 },
            color: "success",
            className: "btn btn-xs",
            type: "button",
            onClick: () => handleEdit(row),
          }}
        >
          Edit
        </Btn>
      </span>
    ),
  }));

  const diagnosistypetableColumns = [
    { name: "#", selector: (row) => row["ind"], sortable: true },
    {
      name: "Diagnosis Type",
      selector: (row) => row["diagnosistype"],
      sortable: true,
      center: true,
    },
    // {
    //   name: "Action",
    //   selector: (row) => row.action,
    //   sortable: false,
    //   center: true,
    // },
  ];

  if (permission?.edit_access) {
    diagnosistypetableColumns.push({
      name: "Action",
      selector: (row) => row["action"],
      sortable: false,
      center: true,
    });
  }

  const [data, setData] = useState(type);

  const fetchDiagnosisType = async () => {
    const response = await DiagnosisTypeList();
    if (response.status === true) {
      setDiagnosisTypes(response.data);
    }
  };

  const handleSaveForm = async (data) => {
    const formattedData = {
      name: data.diagnosistype,
      id: data.id,
    };

    console.warn(formattedData)
    setIsLoading(!isLoading);
    try {
      if (data.id) {
        const response = await UpdateDiagnosisType(formattedData);
        if (response.status === true) {
          setDiagnosisTypes((prev) =>
            prev.map((item) =>
              item.id === formdata.id
                ? { ...item, name: formattedData.name }
                : item
            )
          );
          toast.success("Updated Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
          reset()
          setTimeout(() => {
            window.location.reload();
            }, 2000);
        }
      } else {
        const response = await CreateDiagnosisType(formattedData);
        if (response.status === true) {
          setDiagnosisTypes((prev) => [...prev, response.data]);
          toast.success("Created Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
      fetchDiagnosisType();
      LargeModaltoggle();
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setTimeout(() => {
        setIsLoading(isLoading);
      }, 300);
    }
    reset({ diagnosistype: "" });
  };

  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: "Are you sure you want to delete?",
      cancelButtonText: "No!",
      confirmButtonText: "Yes!",
      reverseButtons: true,
      showCancelButton: true,
    });

    if (result.isConfirmed) {
      try {
        const selectedIds = selectedRows.map((row) => row.id);
        await Promise.all(selectedIds.map((id) => DeleteDiagnosisType(id)));
        setDiagnosisTypes(
          diagnosisTypes.filter((item) => !selectedIds.includes(item.id))
        );
        setSelectedRows([]);
        toast.success("Deleted Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      } catch (error) {
        toast.error("An error occurred!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      finally{
        setTimeout(() => {
          window.location.reload();
          }, 200);
      }
    }
  };

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  useEffect(() => {
    fetchDiagnosisType();
  }, []);

  return (
    <Suspense fallback={Loader}>
      <Card>
        <Breadcrumbs
          mainTitle="Diagnosis Type"
          parent="Dashboard"
          title="diagnosistype"
        />
        <CardHeader className="card-no-border">
          <div className="header-top">
            <Fragment>
              <div className="search">
                <FormGroup className="form-group">
                  <div className="input-group">
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="search"
                      defaultValue={searchKeyword}
                      onChange={(e) => handleSearchKeyword(e.target.value)}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">
                        <i className="fa fa-search"></i>
                      </span>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </Fragment>
            <div className="card-header-right-icon">
              {permission?.create_access && <Btn
                attrBtn={{
                  color: "light-primary",
                  className: "btn badge-light-primary",
                  onClick: ()=>LargeModaltoggle("add"),
                }}
              >
                + Add Diagnosis Type
              </Btn> }
              <CommonModal
                isOpen={Large}
                title={"Diagnosis Type"}
                toggler={LargeModaltoggle}
                size="lg"
                // onSave={handleSaveForm}
                onSave={handleSubmit(handleSaveForm)}
                // handleSubmit={handleSubmit}
                formdata={formdata}
              >
                <Row>
                  <Col sm="12">
                    <FormGroup className="mb-3">
                      <Label htmlFor="fname">
                        {"Diagnosis Type"} <RequiredField />
                      </Label>
                      <input
                        className={`form-control ${
                          errors.diagnosistype && "is-invalid"
                        }`}
                        id="diagnosistype"
                        type="text"
                        name="diagnosistype"
                        defaultValue={formdata.diagnosistype || ""}
                        {...register("diagnosistype", { required: true })}
                      />
                      <span className="text-danger">
                        {errors.diagnosistype && "Diagnosis Type is required"}
                      </span>
                    </FormGroup>
                  </Col>
                </Row>
              </CommonModal>
            </div>
          </div>
        </CardHeader>
        <CardBody className="pt-0 campaign-table">
          {isLoading && (
            <FadeLoader loading={isLoading} cssOverride={override} size={150} />
          )}
          <div className="recent-table table-responsive currency-table">
            <Fragment>
              {selectedRows.length !== 0 && (
                <div
                  className={`d-flex align-items-center justify-content-between bg-light-info p-2`}
                >
                  <H4 attrH4={{ className: "text-muted m-0" }}>
                    Delet Selected Data..!
                  </H4>
                  <Btn
                    attrBtn={{ color: "danger", onClick: () => handleDelete() }}
                  >
                    Delete
                  </Btn>
                </div>
              )}
              <DataTable
                data={type}
                columns={diagnosistypetableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
              />
            </Fragment>
          </div>
        </CardBody>
      </Card>
    </Suspense>
  );
};

export default DiagnosisType;
